import { render } from "./finish.vue?vue&type=template&id=3827f0d5"
import script from "./finish.vue?vue&type=script&lang=js"
export * from "./finish.vue?vue&type=script&lang=js"
script.render = render

export default script